
// credit: https://stackoverflow.com/questions/1573053/javascript-function-to-convert-color-names-to-hex-codes
// (formatting copied)
export function getHexColor(colorStr) {
  const a = document.createElement('div');
  a.style.color = colorStr;
  const colors = window.getComputedStyle( document.body.appendChild(a) ).color.match(/\d+/g).map(function(a){ return parseInt(a,10); });
  document.body.removeChild(a);
  return (colors.length >= 3) ? '#' + (((1 << 24) + (colors[0] << 16) + (colors[1] << 8) + colors[2]).toString(16).substring(1)) : undefined;
}

// credit: https://stackoverflow.com/questions/5560248/programmatically-lighten-or-darken-a-hex-color-or-rgb-and-blend-colors
// (formatting copied)
// usage: stepAmount is negative (use minus sign) to lighten the color, and no sign for darker
export function adjustBrightness(colorHex, stepAmount) {
  let usePound = false;
  if (colorHex[0] === "#") {
    colorHex = colorHex.slice(1);
    usePound = true;
  }
  let R = parseInt(colorHex.substring(0,2),16);
  let G = parseInt(colorHex.substring(2,4),16);
  let B = parseInt(colorHex.substring(4,6),16);

  // change the - to + here to reverse the lighten/darken usage so darker needs a negative number
  R = R - stepAmount;
  G = G - stepAmount;
  B = B - stepAmount;

  if (R > 255) R = 255;
  else if (R < 0) R = 0;

  if (G > 255) G = 255;
  else if (G < 0) G = 0;

  if (B > 255) B = 255;
  else if (B < 0) B = 0;

  let RR = ((R.toString(16).length===1)?"0"+R.toString(16):R.toString(16));
  let GG = ((G.toString(16).length===1)?"0"+G.toString(16):G.toString(16));
  let BB = ((B.toString(16).length===1)?"0"+B.toString(16):B.toString(16));

  return (usePound?"#":"") + RR + GG + BB;
}